import { Dialog } from "@progress/kendo-react-dialogs";
import { getDatalakeImageUrl } from "../../Helpers/DateLakeStorage";
import { useState } from "react";

function ErrorDialog({ errorId, errorMessage, toggleErrorDialog }) {

    const [showMore, setShowMore] = useState(false);

    return (
        <Dialog
            title={"Something went wrong"}
            width={"50rem"}
            onClose={toggleErrorDialog}
        >
            <div className="d-flex flex-column justify-content-center align-items-center h-100 w-100">
                <div className="col-12 text-center">
                    <img
                        width={"170rem"}
                        src={getDatalakeImageUrl("something-went-wrong-dialog-image.png")} />
                </div>
                <div className="row">
                    <div className="col-12 text-center py-3">
                        <h3>It seems something went wrong</h3>
                    </div>
                    <div className="col-12 py-2 text-center">
                        <p className='font-size-3'>
                            <div>
                                Error Id - {errorId}
                            </div>
                            {
                                showMore &&
                                <div>
                                    Error: { errorMessage }
                                </div>
                            }
                            <button
                                className="btn btn-link"
                                onClick={() => setShowMore(!showMore)}
                            >
                                {
                                    showMore ? "Show less" : "Show more"
                                }
                            </button>
                        </p>
                    </div>
                    <div className="col-12 text-center py-2">
                        <p className='font-size-3'>
                            Please contact the Codeless ONE support team if you want to report this issue.
                        </p>
                        <p className="font-size-3">
                            <a href="mailto:support@codelessone.com">
                                support@codelessone.com
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </Dialog>
    )
}

export default ErrorDialog;